import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--bookings--extra"
export default class extends Controller {
  static targets = [
    "extrasContainer",
    "resetButton",
    "extrasButton",
    "buttonPlusIcon",
    "buttonMinusIcon",
    "serviceSelect",
    "extraItem"
  ]

  connect() {
    this.init()
  }

  init() {
    if (this.extraItemTargets.some(extra => extra.checked)) {
      this.extrasContainerTarget.classList.remove("hidden")
      this.extrasButtonTarget.disabled = false
      this.resetButtonTarget.classList.remove("hidden")
    }

    if (this.serviceSelectTarget.value !== "") {
      this.resetButtonTarget.classList.remove("hidden")
      this.extrasButtonTarget.disabled = false
    }
  }

  toggleExtras(_) {
    this.extrasContainerTarget.classList.toggle("hidden")
    this.buttonPlusIconTarget.classList.toggle("hidden")
    this.buttonMinusIconTarget.classList.toggle("hidden")
  }

  selectService(event) {
    if (event.target.value !== "") {
      this.resetButtonTarget.classList.remove("hidden")
      this.extrasButtonTarget.disabled = false
    } else {
      this.resetButtonTarget.classList.add("hidden")
      this.extrasButtonTarget.disabled = true
    }
  }

  resetService(_) {
    this.serviceSelectTarget.value = ""
    this.resetButtonTarget.classList.add("hidden")
    this.extrasContainerTarget.classList.add("hidden")
    this.buttonPlusIconTarget.classList.remove("hidden")
    this.buttonMinusIconTarget.classList.add("hidden")

    this.extraItemTargets.forEach(extra => { extra.checked = false })
    this.extrasButtonTarget.disabled = true
  }
}
